const brCategory = {
  category: {
    label: {
      name: 'Nome',
    },

    action: {
      cancel: 'Cancelar',
      edit: 'Editar categoria',
      create: 'Criar categoria',
      delete: 'Apagar categoria',
      loading: 'Carregando categoria',
    },

    hints: {
      delete: 'Deseja mesmo apagar esta categoria?',
    },

    messages: {
      successfullyCreated: 'Categoria criada com sucesso',
      successfullyEdited: 'Categoria editada com sucesso',
      successfullyDeleted: 'Categoria removida com sucesso',
    },
  },
}

export default brCategory
